<template>
  <div id="app">
    <keep-alive><router-view v-if="$route.meta.keepAlive"/></keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  @import "../static/colorui.css";
  html,body{
    background-color: #ffffff;
    box-sizing: border-box;
  }
  html,body,p,div{
    margin: 0;padding: 0;
  }
  a{
    text-decoration: none;
  }
  a:link{
    text-decoration: none;
  }
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.toast-center.et-wrapper.et-top{
  top:50%
}
.et-wrapper .et-content{
  font-size:13px;
  font-weight:400;
  color:rgba(255,255,255,1);
}
.toast-success.et-wrapper.et-top{
  top:30%
}
.toast-success.et-wrapper{
  width: 120px!important;
  height: 120px!important;
  min-width: 120px!important;
  min-height: 120px!important;
  padding: 0;
}
.toast-success.et-wrapper:before{
  content: " ";
  display: block;
  width:50px;
  height:35px;
  background-image: url("http://assets.pfotoo.com/nuoche/right.png");
  margin: 25px auto 13px;
  background-size: 100% 100%
}
.flex-vc{
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  -webkit-flex-direction: column;
}
.flex-lr{
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items:center;
  flex-direction: row;
  -webkit-flex-direction: row;
}
.flex-ll{
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  -webkit-flex-direction: row;
}
.flex-rr{
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: row;
  -webkit-flex-direction: row;
}
.box-sizing{
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue